import React from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import {SketchPicker} from 'react-color';
import './create.scss';

import InputContainer from 'components/InputContainer';

const CreateRole = ({isOpened, onClose, onSave, role, setRole}) => (
  <Modal isOpen={isOpened} toggle={onClose} centered>
    <ModalHeader toggle={onClose}>Create Role</ModalHeader>
    <ModalBody>
      <div className="d-flex flex-column">
        <InputContainer
          type="text"
          value={role.title}
          placeholder="Enter Role name"
          handleChange={(event) => {
            const newRole = {...role, title: event.target.value};
            setRole(newRole);
          }}
          inputClass="form-control"
        />
        <InputContainer
          type="text"
          value={role.description}
          placeholder="Enter Role description"
          handleChange={(event) => {
            const newRole = {...role, description: event.target.value};
            setRole(newRole);
          }}
          inputClass="form-control"
        />
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label className="mt-4">Role color</label>
        <SketchPicker
          color={role.color}
          className="mt-1"
          onChangeComplete={(e) => {
            const newRole = {...role, color: e.hex};
            setRole(newRole);
          }}
        />
      </div>
    </ModalBody>
    <ModalFooter>
      <Button color="primary" onClick={onClose}>
        Cancel
      </Button>
      <Button color="secondary" onClick={onSave}>
        Save
      </Button>
    </ModalFooter>
  </Modal>
);

export default CreateRole;
